var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","placement":"top-end","open-delay":_vm.openDelay,"content":_vm.tip}},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-link"},on:{"click":_vm.open}},[_vm._v("\n    "+_vm._s(_vm.$t('route.website'))+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }